export { ConfluenceArticleIFrame } from './confluence-article-iframe';
